import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "grid"]

  triggerUpload() {
    this.inputTarget.click()
  }

  preview() {
    const files = this.inputTarget.files
    if (!files.length) return

    this.gridTarget.classList.remove("hidden")
    this.gridTarget.innerHTML = ""

    Array.from(files).slice(0, 10).forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const div = document.createElement("div")
        div.className = "relative aspect-square rounded-lg overflow-hidden bg-white/5"
        div.innerHTML = `
          <img src="${e.target.result}" class="w-full h-full object-cover" alt="Photo ${index + 1}">
        `
        this.gridTarget.appendChild(div)
      }
      reader.readAsDataURL(file)
    })
  }
}
